// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vQt6","placeholdersHeader":"styles_placeholdersHeader__3wNKu","editorStyle":"styles_editorStyle__1LvAr","placeholdersBox":"styles_placeholdersBox__2TlUQ"};